import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
import { Spinner } from '@material-tailwind/react'
import nexus from '../../assets/nexusLogo.png'
import AppFooter from '../../Components/AppFooter'

const RequestChangeCreds = () => {
  const [isLoad, setIsLoad] = useState(false)
  const [userCredentials, setUserCredentials] = useState({ email: '' })
  const [countdown, setCountdown] = useState(() => {
    const savedCountdown = localStorage.getItem('countdown')
    return savedCountdown ? parseInt(savedCountdown, 10) : 0
  })

  useEffect(() => {
    let timer
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1)
        localStorage.setItem('countdown', countdown - 1)
      }, 1000)
    } else {
      localStorage.removeItem('countdown')
    }
    return () => clearTimeout(timer)
  }, [countdown])

  const reqResetPassword = (e) => {
    e.preventDefault()
    setIsLoad(true)
    axios
      .post('/api/users/auth/request-password-reset', { email: userCredentials.email })
      .then((response) => {
        toast.success(response.data.message)
        setIsLoad(false)
        setCountdown(30)
        localStorage.setItem('countdown', 30)
      })
      .catch((error) => {
        console.error('Error:', error)
        setIsLoad(false)
        const errorMessage =
          error.response?.data?.message || 'An error occurred during password reset.'
        toast.error(errorMessage)
      })
  }

  return (
    <>
      <div className="nx-app-bg flex min-h-screen w-full flex-col px-4 pb-4">
        <div className="flex flex-1 items-center justify-center py-6">
          <div className="nx-panel w-full max-w-md p-8">
          <p className="nx-manifest-kicker">Account recovery</p>
          <div className="my-6 flex items-center gap-2">
            <div className="h-10 w-44">
              <img src={nexus} className="h-full w-full object-contain object-left" alt="Nexus V2" />
            </div>
            <span className="rounded-md border border-signal/40 bg-signal/10 px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wider text-signal">
              V2
            </span>
          </div>
          <h1 className="font-display text-3xl tracking-wide text-paper">Password recovery</h1>
          <p className="mt-2 text-sm text-muted">
            Enter your email to request a password recovery link.
          </p>

          <form onSubmit={reqResetPassword} className="mt-6 space-y-4">
            <div>
              <label htmlFor="email" className="nx-label">
                Email
              </label>
              <input
                id="email"
                className="nx-input"
                type="email"
                required
                value={userCredentials.email}
                onChange={(e) => setUserCredentials({ ...userCredentials, email: e.target.value })}
              />
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <button
                className="nx-btn-primary"
                type="submit"
                disabled={isLoad || countdown > 0}
              >
                {isLoad ? (
                  <span className="flex items-center gap-2">
                    Sending
                    <Spinner className="h-4 w-4" color="blue" />
                  </span>
                ) : (
                  'Send link'
                )}
              </button>
              {countdown > 0 && (
                <p className="font-mono text-xs text-muted">Resend in {countdown}s</p>
              )}
            </div>
          </form>

          <Link to="/login" className="mt-8 inline-flex items-center gap-2 text-sm text-muted hover:text-signal">
            <ArrowLongLeftIcon className="h-4 w-4" />
            Back to login
          </Link>
          </div>
        </div>
        <AppFooter className="mx-auto w-full max-w-7xl" />
      </div>
    </>
  )
}

export default RequestChangeCreds
